<template>
  <v-container>
    <v-list-item-title class="headline mb-1 title cloud-title">Size</v-list-item-title>
    <v-layout wrap class="text-center" justify-space-around>
      <v-row no-gutters class="mr-2 ml-5">
      <template v-for="(size, index) in sizes">
        <v-col :key="size.Id" >
          <v-card
            class="size mr-5 mt-3"
            :class="{ 'selected-size' : size.selected, 'size-error' : errors[0] && !errors[1] }" 
            outlined
            tile
            @click="onSelectedSize(size.Id)"
          >
          <div class="round">
          <input type="checkbox" :id="size.Id" :checked="size.selected" />
          <label :key="size.Id"></label>
          <div class="title-label mb-1">{{ size.Name }}</div>
          <p class="labels"> {{size.vCPU}}CPU &nbsp;&nbsp; {{size.RAM}}GB RAM </p> 
        </div>
          </v-card>
        </v-col>
        <v-responsive
          v-if="index === 2"
          :key="`width-${index}`"
          width="100%"
        ></v-responsive>
      </template>
    </v-row>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
     
    };
  },
  props: ["errors", "sizes"],
  methods: {
    onSelectedSize(id) {
      this.sizes.map(size => size.Id === id ? size.selected = !size.selected : size.selected = false);
      this.$emit("selectedSize", id);
    }
  }
};
</script>

<style scoped>
.round {
  position: relative;
}

.round label {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 28px;
  left: -6px;
  position: absolute;
  top: -6px;
  width: 28px;
  background-color: #e2e2e2;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 7px;
  opacity: 0;
  position: absolute;
  top: 8px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #6db42c;
  border-color: #6db42c;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

.size {
  height: 76px;
  border: 2px solid #eeeeee;
  border-radius: 6px;
  background: #eeeeee 0% 0% no-repeat padding-box;
  color: #6a6a6a;
}

.selected-size {
  background: transparent linear-gradient(180deg, #d0398b 0%, #792d86 100%) 0%
    0% no-repeat padding-box;
  color: white !important;
}

.size-error {
  border-color: red;
}

.title-label {
  font: bold 16px "Montserrat" !important;
}

.title-label::first-letter {
  text-transform: uppercase !important;
}
</style>